var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M5.20285 1.76714L5.81727 2.19723L5.81727 2.19723L5.20285 1.76714ZM4.83786 2.91729L4.86773 3.66669C5.27147 3.6506 5.58989 3.31756 5.58785 2.9135L4.83786 2.91729ZM15.1621 2.91729L14.4122 2.91351C14.4101 3.31756 14.7285 3.6506 15.1323 3.6667L15.1621 2.91729ZM14.7972 1.76714L15.4116 1.33704V1.33704L14.7972 1.76714ZM5.81727 2.19723C6.05118 1.86308 6.43342 1.66406 6.84131 1.66406V0.164062C5.94395 0.164062 5.10303 0.601892 4.58842 1.33704L5.81727 2.19723ZM5.58785 2.9135C5.58665 2.67629 5.65475 2.42941 5.81727 2.19723L4.58842 1.33704C4.24397 1.82912 4.08514 2.3805 4.08787 2.92107L5.58785 2.9135ZM1.75 6.91406C1.75 5.16344 3.13442 3.7358 4.86773 3.66669L4.80798 2.16788C2.27336 2.26893 0.25 4.35502 0.25 6.91406H1.75ZM1.75 11.9141V6.91406H0.25V11.9141H1.75ZM5 15.1641C3.20507 15.1641 1.75 13.709 1.75 11.9141H0.25C0.25 14.5374 2.37665 16.6641 5 16.6641V15.1641ZM15 15.1641H5V16.6641H15V15.1641ZM18.25 11.9141C18.25 13.709 16.7949 15.1641 15 15.1641V16.6641C17.6234 16.6641 19.75 14.5374 19.75 11.9141H18.25ZM18.25 6.91406V11.9141H19.75V6.91406H18.25ZM15.1323 3.6667C16.8656 3.7358 18.25 5.16344 18.25 6.91406H19.75C19.75 4.35502 17.7266 2.26894 15.192 2.16789L15.1323 3.6667ZM14.1827 2.19723C14.3453 2.42941 14.4134 2.6763 14.4122 2.91351L15.9121 2.92108C15.9149 2.38051 15.756 1.82912 15.4116 1.33704L14.1827 2.19723ZM13.1587 1.66406C13.5666 1.66406 13.9488 1.86308 14.1827 2.19723L15.4116 1.33704C14.897 0.601892 14.0561 0.164062 13.1587 0.164062V1.66406ZM6.84131 1.66406H13.1587V0.164062H6.84131V1.66406Z",
    fill: "#3B1F8E"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 685",
    cx: 10,
    cy: 8.91406,
    r: 3,
    stroke: "#3B1F8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.07860b1f88e1a541da9dcbe74416e59b.svg";
export { ForwardRef as ReactComponent };